import { useTipTapEditorContext } from "@circle-react-uikit/TipTap/TipTapEditorContext";

export const useSgidObject = <T>(sgid: string): T | undefined => {
  const context = useTipTapEditorContext() as {
    localSgidToObjectMap?: Record<string, T>;
    sgidToObjectMap?: Record<string, T>;
  } | null;
  return (
    context?.localSgidToObjectMap?.[sgid] ?? context?.sgidToObjectMap?.[sgid]
  );
};
